import './index.scss';
import { useSelector } from 'react-redux';
import { Feedback } from '../Feedback';
import { iconsData } from './iconsData';
import { environment } from '@env';
import { canAllowSupportPageSelector } from '@selectors/app';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const canAllowSupportPage = useSelector(canAllowSupportPageSelector);

  return (
    <div className="footer-grid-container">
      <div className="copyright-info">
        <p className="footer-logo-small-container"></p>
        <p>&copy; {currentYear} All Rights Reserved.</p>
        <p>Version {environment.VERSION}</p>
      </div>
      <div>
        <ul className="social-link-list">
          {iconsData.map((icon, i) => (
            <a href={icon.href} key={i} className="social-item" target="blank">
              <img src={icon.src} className="social-icon" alt="social-icon" />
            </a>
          ))}
        </ul>
        {canAllowSupportPage && <Feedback />}
      </div>
    </div>
  );
};
